import type { HeaderGroup } from '@tanstack/react-table';
import { TH } from './th/th';
import styles from './table-header.module.scss';

interface TableHeaderProps<T extends object> {
  groups: HeaderGroup<T>[];
}

export function TableHeader<T extends object>({ groups }: TableHeaderProps<T>) {
  // 'use no memo' directive is required for now because react-table v8 is not compatible with React 19's compiler just yet
  'use no memo';

  return (
    <thead className={styles.tableHeader} data-sticky-header="true">
      {groups.map((group) => (
        <tr className={styles.headerRow} key={group.id}>
          {group.headers.map((header) => (
            <TH<T> header={header} key={header.id} />
          ))}
        </tr>
      ))}
    </thead>
  );
}
